// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupsUsingCatalogsResult = objectOf({
  app_groups: arrayOf(
    objectOf({
      id: string,
      catalogs: number,
      items: number,
      name: string,
    })
  ),
});
